"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderClientModel = void 0;
var order_line_client_model_1 = require("./order-line.client.model");
var order_count_client_model_1 = require("./order-count.client.model");
var OrderClientModel = /** @class */ (function () {
    function OrderClientModel(serverModel) {
        this.id = serverModel.id;
        this.dateCreated = serverModel.created_at;
        this.totalLineItems = serverModel.order_line.length;
        this.status = serverModel.status;
        this.addressFrom = '';
        this.addressTo = '';
        var addressTo = serverModel.addresses.find(function (address) { return address.pivot.address_type === 'to'; });
        if (addressTo) {
            this.addressTo = this.prepareAddress(addressTo);
        }
        var addressFrom = serverModel.addresses.find(function (address) { return address.pivot.address_type === 'from'; });
        if (addressFrom) {
            this.addressFrom = this.prepareAddress(addressFrom);
        }
        this.shippingCarrier = serverModel.shipping_carrier;
        this.shippingPriority = serverModel.shipping_priority;
        this.lineItems = serverModel.order_line.map(function (item) { return new order_line_client_model_1.OrderLineClientModel(item); });
        this.orderRef = serverModel.order_ref;
        this.reprint = serverModel.reprint;
        this.xqc = serverModel.xqc;
        this.statusFormatted = this.status.name.replace(new RegExp('_', 'g'), ' ');
        this.order_submission_log = serverModel.order_submission_log
            ? new order_count_client_model_1.OrderSubmissionClientModel(serverModel.order_submission_log)
            : null;
    }
    OrderClientModel.prototype.prepareAddress = function (address) {
        return "\n    " + (address.first_name || '') + " " + (address.last_name || '') + " " + (address.first_name || address.last_name ? ',' : '') + "\n    " + address.address1 + ", " + address.city + ", " + address.country;
    };
    return OrderClientModel;
}());
exports.OrderClientModel = OrderClientModel;
